import React from 'react';
import styled from 'styled-components';
import TextBlock from '@component/common/block/text-block';
import TextButton from '@design-system/text-button';
import Gap from '@component/common/gap';
import { ETheme } from '@datatype/type';
import * as color from '@constant/color';
import * as size from '@constant/size';

interface IProps {
  handleClose: () => void;
}

const Wrapper = styled.div`
  display: flex;
  width: ${size.MEDIUM_MODAL_WIDTH};
  flex-flow: column nowrap;
  align-items: center;
`;

const FeaturePlannedModal: React.FC<IProps> = ({ handleClose }) => (
  <Wrapper>
    <TextBlock text='곧 서비스할 예정이에요.' design={{ text: { size: 'large', color: color.BLACK_2, bold: true } }} />
    <Gap height={size.MARGIN_2} />
    <TextButton
      text='확인'
      theme={ETheme.BROWN}
      kind='filled'
      size='medium'
      shape='pill'
      width='100%'
      handleClick={handleClose}
    />
  </Wrapper>
);

export default FeaturePlannedModal;
